// extracted by mini-css-extract-plugin
module.exports = {"label":"RecentSearches_label__2MAEk","content":"RecentSearches_content__3JzVo"};